import React, { useContext } from 'react';
import { useServices } from 'app/hooks';
import { useEffect, useState } from 'react';
import AppContext from 'app/AppContext';

export function MeasuredMemory() {
    const { memoryMonitoring } = useServices();
    const [memory, setMemory] = useState(0);
    const [memoryDate, setMemoryDate] = useState(new Date());
    const { timeFormat } = useContext(AppContext);

    useEffect(() => {
        const last = memoryMonitoring.subscribe((r) => {
            if (r) {
                setMemory(r.bytes);
                setMemoryDate(new Date());
            }
        });
        if (last) {
            setMemory(last.result.bytes);
            setMemoryDate(last.timeStamp);
        }
    }, [memoryMonitoring]);

    if (memory === 0) {
        return <></>;
    }

    const toolTip = `Memory measured at ${timeFormat.toTimeSeconds(
        memoryDate.getTime()
    )}`;

    return (
        <div className="MeasuredMemory" title={toolTip}>
            {memory} bytes
        </div>
    );
}
